import React from 'react';

import { Button, Checkbox, Flex, Table } from 'antd';
import { useTranslation } from 'react-i18next';

import { useAppDispatch } from 'segments/hooks';
import i18n from 'segments/i18n';

import { useTimezone } from 'features/user';
import { UserActions } from 'features/users';

import { changeActiveGroupeId, changeGroupsActiveModal } from '../store/Slice';
import { GroupeUser } from '../store/types';
import { convertGroupeUsersToTable } from '../utils/transformer';


export interface TableData extends GroupeUser {
  key: number;
}

type Props = {
  items: GroupeUser[];
  isLoading?: boolean;
  groupeId: number;
};

export const MinUsersTable = (props: Props) => {
  const {
    items,
    isLoading,
    groupeId
  } = props;

  const dispatch = useAppDispatch();
  const { timezone } = useTimezone();
  const { t } = useTranslation(undefined, { keyPrefix: 'table' });

  const handlleAddUser = () => {
    dispatch(changeGroupsActiveModal('add-user-groupe'));
    dispatch(changeActiveGroupeId(groupeId));
  };

  return (
    <Table<TableData>
      size="small"
      dataSource={convertGroupeUsersToTable(timezone, items)}
      loading={isLoading}
      scroll={{ x: 1200 }}
      pagination={false}
    >
      <Table.Column<TableData>
        title={t('id', 'ID')}
        dataIndex="id"
        width={100}
      />
      <Table.Column<TableData>
        title={t('fio', 'ФИО')}
        dataIndex="name"
        width={130}
      />
      <Table.Column<TableData>
        title={t('birth-date', 'Названия')}
        dataIndex="birthDate"
        width={100}
        render={(birthDate: string) => birthDate?.slice(0, 4) ?? i18n.t('without')}
      />
      <Table.Column<TableData>
        title={t('note')}
        dataIndex="note"
        width={130}
        render={(note: string) => note ?? i18n.t('without')}
      />
      <Table.Column<TableData>
        title={t('contacts', 'Контакты')}
        dataIndex="email"
        width={250}
        render={(_, { phone, email }) => (
          <>
            {email && <p>{email}</p>}
            {phone && <p>{phone}</p>}
          </>
        )}
      />
      <Table.Column<TableData>
        title={t('current-month', 'ФИО')}
        dataIndex="currentMonthPaid"
        render={(isPaid: boolean) => (
          <Checkbox
            disabled
            checked={isPaid}
          />
        )}
        width={90}
      />
      <Table.Column<TableData>
        title={t('next-month', 'ФИО')}
        dataIndex="nextMonthPaid"
        render={(isPaid: boolean) => (
          <Checkbox
            disabled
            checked={isPaid}
          />
        )}
        width={90}
      />
      <Table.Column<TableData>
        dataIndex=""
        width={180}
        fixed="right"
        title={
          <Flex justify='flex-end'>
            <Button type="primary" onClick={handlleAddUser}>{t('add-user')}</Button>
          </Flex>
        }
        render={(_, user) => (
          <Flex justify='flex-end'>
            <UserActions
              user={user}
            />
          </Flex>
        )}
      />
    </Table>
  );
};
